import React from 'react';
// Type defintitions
import * as TYPES from '../types'; // JSS

import { Image } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../components/link/Link';

var Logo = function Logo(_ref) {
  var _model$logo, _model$logo$url;

  var model = _ref.model;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SitecoreLink, {
    field: model.logo.url,
    className: "cb-logo",
    id: model === null || model === void 0 ? void 0 : (_model$logo = model.logo) === null || _model$logo === void 0 ? void 0 : (_model$logo$url = _model$logo.url) === null || _model$logo$url === void 0 ? void 0 : _model$logo$url.id
  }, /*#__PURE__*/React.createElement(Image, {
    media: model.logo.image
  })));
};

export default Logo;